import { registerDestructor } from '@ember/destroyable';
import Modifier from 'ember-modifier';

interface ScrollPositionSignature {
  Args: {
    Positional: [onScrollCallback: (event: Event) => void];
  };
  Element: HTMLElement;
}

function cleanup(instance: ScrollPositionModifier): void {
  if (instance.element) {
    instance.element.removeEventListener(
      'scroll',
      instance.onScroll.bind(instance),
    );
    instance.element = null;
  }
}

/**
 * Modifier to track scroll position of an element and notify via callback
 */
export default class ScrollPositionModifier extends Modifier<ScrollPositionSignature> {
  element: HTMLElement | null = null;
  onScrollCallback: (event: Event) => void = (): void => {};

  modify(
    element: ScrollPositionSignature['Element'],
    [onScrollCallback]: ScrollPositionSignature['Args']['Positional'],
  ): void {
    element.addEventListener('scroll', this.onScroll.bind(this));
    this.element = element;
    this.onScrollCallback = onScrollCallback;

    registerDestructor(this, cleanup);
  }

  onScroll(event: Event): void {
    const scrollContainer = this.element;
    if (!scrollContainer) {
      return;
    }
    this.onScrollCallback(event);
  }
}
